import { Button } from '@forwardflow/ui'
import Icon from '@forwardflow/ui/Icons'
import { Select, Tour } from 'antd'
import { Link, Outlet } from 'react-router-dom'

import { RecommendedLead } from './RecommendedLead'
import { LeadConversationStats } from './LeadConversationStats'
import { useEffect, useRef, useState } from 'react'
import type { TourProps } from 'antd'
import { useGetAllRecommendedCampaign } from '@forwardflow/hooks/customHooks/campaign'
import { IRecommendedCampaign } from '@forwardflow/types'

export const CampaignComponent = () => {
   const { data: recommendedCampaigns } = useGetAllRecommendedCampaign()
   const [selectedDays, setSelectedDays] = useState<string>('All Time')
   const ref1 = useRef(null)
   const ref2 = useRef(null)

   const isTourDone = localStorage.getItem('isCampaignTourDone') === 'true'
   const [open, setOpen] = useState<boolean>(!isTourDone)

   const steps: TourProps['steps'] = [
      {
         title: null,
         description: (
            <div className="flex items-center px-6">
               <Icon name="TourIcon" />
               <p className="p-6 font-semibold">
                  You can active auto nurture Campaigns on the recommended lead
                  sources for the best results
               </p>
            </div>
         ),
         className: 'ff-tour-step',

         target: () => ref1.current,
      },
      {
         title: null,
         description: (
            <>
               <div className="flex items-center px-6">
                  <Icon name="TourIcon" />
                  <p className="p-6 font-semibold">
                     You can also active auto nurture Campaigns on any of your
                     lead sources from this table
                  </p>
               </div>
            </>
         ),
         className: 'ff-tour-step',
         placement: 'left',
         target: () => ref2.current,
      },
   ]

   useEffect(() => {
      if (!open) {
         localStorage.setItem('isCampaignTourDone', 'true')
      }
   }, [open])
   return (
      <>
         <div className="bg-white/5 h-[60px] rounded-lg flex items-center">
            <Link to="/dashboard">
               <Button className="!w-[54px] h-[54px] border-transparent bg-transparent !rounded-lg !mt-0 ml-1 mr-5">
                  <Icon
                     name="arrow-right"
                     className="rotate-180 fill-white"
                     width={20}
                     height={20}
                  />
               </Button>
            </Link>
            <span className="text-[#717171] text-[20px]">
               <Link to="/dashboard"> Home /</Link>
               <span className="text-white"> Campaigns</span>
            </span>
            <div className="ml-auto mr-5 flexc">
               <Select
                  className="min-w-[150px] dashboard-select !h-9 rounded"
                  placeholder="All Time"
                  defaultValue={selectedDays}
                  options={[{ label: 'Last 6 months', value: 'All Time' }]}
                  onChange={(value) => setSelectedDays(value)}
               />
            </div>
         </div>
         <div className="flex flex-col gap-5 mt-10 xl:flex-row">
            <div className="xl:w-2/5">
               <div ref={ref1} className="h-[182px]">
                  <RecommendedLead
                     recommendedCampaigns={
                        (recommendedCampaigns ||
                           []) as unknown as IRecommendedCampaign[]
                     }
                  />
               </div>

               <LeadConversationStats selectedDays={selectedDays} />
            </div>
            <div className="xl:w-3/5">
               <div ref={ref2}>
                  <Outlet></Outlet>
               </div>
            </div>
         </div>
         <Tour
            open={open}
            onClose={() => setOpen(false)}
            steps={steps}
            closeIcon={false}
            mask={{
               style: {
                  boxShadow: 'inset 0 0 15px #333',
               },
               color: 'rgba(24, 25, 29, 0.8)',
            }}
         />
      </>
   )
}
